module.exports = __webpack_public_path__ + "static/img/banner_title.7dff779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ds_img/banner_title.png
// module id = POP6
// module chunks = 18